module.exports = __webpack_public_path__ + "img/ticVerde.42a3075f.png";